import React from "react";
import { Button } from "@ann/web-components";
import SkeletonCard from "../SkeletonCard";
import { ButtonContainer } from "./LoadMoreSection.styled";

export const LoadMoreSection = ({
  hasMore,
  isLoading,
  onLoadMore,
  skeletonType,
  skeletonCount = 8,
  buttonLabel,
}) => {
  if (!hasMore && !isLoading) return null;

  if (isLoading) {
    return (
      <>
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <SkeletonCard key={i} type={skeletonType} />
        ))}
        <ButtonContainer>
          <Button size="medium" type="tertiary" disabled label="Loading..." />
        </ButtonContainer>
      </>
    );
  }
  return (
    <ButtonContainer>
      <Button
        size="medium"
        type="tertiary"
        onClick={onLoadMore}
        label={buttonLabel ?? `Load More `}
      />
    </ButtonContainer>
  );
};
